// Constants
const LOAD_INIT = 'OVID/VISTA360/ORDER_DETAIL_INIT'
const LOAD_SUCCEEDED = 'OVID/VISTA360/ORDER_DETAIL_SUCCEEDED'
const LOAD_FAILED = 'OVID/VISTA360/ORDER_DETAIL_FAILED'

export const constants = {
  LOAD_INIT,
  LOAD_SUCCEEDED,
  LOAD_FAILED,
}
